import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { MedicationActionV2 } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-medication-slot-v2',
    templateUrl: './medication-slot-v2.component.html',
    styleUrl: './medication-slot-v2.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MedicationSlotComponentV2 implements SheetSlotComponentBase {

	action!: MedicationActionV2;
	value!: string | null;

	@Input('action') set updateAction(action: MedicationActionV2 | null) {
		this.action = action as MedicationActionV2;
		this.value = this.action.amountGiven?.quantity?.toString() ?? null;
	}

	constructor() {
	}
}